import axios from './axios'
import config from '../config'
export default {
    listViewStyles(params) {
        return axios({
            url: config.backendUrl + '/common/view-styles',
            method: 'GET',
            params
        })
    },
    addViewStyle(data) {
        return axios({
            url: config.backendUrl + '/op/view-styles',
            method: 'POST',
            data
        })
    },
    updateViewStyle(id, data) {
        return axios({
            url: config.backendUrl + '/op/view-styles/' + id,
            method: 'PUT',
            data
        })
    },
    getViewStyle(id) {
        return axios({
            url: config.backendUrl + '/common/view-styles/' + id,
            method: 'GET'
        })
    },
    deleteViewStyle(id) {
        return axios({
            url: config.backendUrl + '/op/view-styles/' + id,
            method: 'DELETE'
        })
    }
}
